module.exports = __webpack_public_path__ + "img/energy-providers.8c911d0.png";